module.exports = __webpack_public_path__ + "static/media/burns.4e3fa76b.png";